var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    viewBox: "0 0 180 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 52H6.66667C3.00167 52 0 49.0734 0 45.5V6.5C0 2.92663 3.00167 2.74817e-06 6.66667 2.74817e-06H173.333C176.998 2.74817e-06 180 2.92663 180 6.5V45.5C180 49.0734 176.998 52 173.333 52Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 1.04162C176.42 1.04162 178.932 3.4905 178.932 6.5V45.5C178.932 48.5095 176.42 50.9584 173.333 50.9584H6.66667C3.58 50.9584 1.06833 48.5095 1.06833 45.5V6.5C1.06833 3.4905 3.58 1.04162 6.66667 1.04162H173.333ZM173.333 2.74817e-06H6.66667C3.00167 2.74817e-06 0 2.92663 0 6.5V45.5C0 49.0734 3.00167 52 6.66667 52H173.333C176.998 52 180 49.0734 180 45.5V6.5C180 2.92663 176.998 2.74817e-06 173.333 2.74817e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9134 9.80032C13.5217 10.2001 13.295 10.8224 13.295 11.6284V40.3779C13.295 41.1839 13.5217 41.8063 13.9134 42.2061L14.01 42.2938L30.5334 26.1901V25.8098L14.01 9.70607L13.9134 9.80032Z",
    fill: "url(#paint0_linear_6203_5344)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.035 31.5607L30.5333 26.19V25.8098L36.0417 20.4392L36.165 20.509L42.6883 24.1279C44.55 25.1549 44.55 26.8449 42.6883 27.8784L36.165 31.4908L36.035 31.5607Z",
    fill: "url(#paint1_linear_6203_5344)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.165 31.4908L30.5333 26L13.9133 42.2061C14.5317 42.8398 15.54 42.9162 16.6867 42.2825L36.165 31.4908Z",
    fill: "url(#paint2_linear_6203_5344)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.165 20.5091L16.6867 9.71751C15.54 9.09025 14.5317 9.16663 13.9133 9.80038L30.5333 26L36.165 20.5091Z",
    fill: "url(#paint3_linear_6203_5344)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2233 13.3168C63.2233 14.4023 62.89 15.2717 62.2333 15.9201C61.4783 16.6887 60.495 17.0754 59.29 17.0754C58.1383 17.0754 57.155 16.6822 56.3483 15.9071C55.54 15.1206 55.1367 14.1553 55.1367 12.9999C55.1367 11.8446 55.54 10.8793 56.3483 10.0993C57.155 9.31769 58.1383 8.92444 59.29 8.92444C59.8633 8.92444 60.41 9.03981 60.9317 9.25431C61.4517 9.47044 61.875 9.76294 62.1817 10.1237L61.485 10.8094C60.95 10.1936 60.2217 9.88969 59.29 9.88969C58.45 9.88969 57.7217 10.1757 57.1033 10.7526C56.4917 11.3311 56.185 12.0802 56.185 12.9999C56.185 13.9197 56.4917 14.6753 57.1033 15.2538C57.7217 15.8242 58.45 16.1167 59.29 16.1167C60.1817 16.1167 60.9317 15.8242 61.5233 15.2473C61.9133 14.8654 62.135 14.3389 62.1933 13.6662H59.29V12.7269H63.1633C63.21 12.9301 63.2233 13.1267 63.2233 13.3168Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3683 10.0603H65.73V12.5303H69.01V13.4695H65.73V15.9395H69.3683V16.8966H64.7V9.10315H69.3683V10.0603Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 16.8966H72.675V10.0603H70.4433V9.10315H75.9383V10.0603H73.705V16.8966Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.915 16.8966V9.10315H80.9434V16.8966H79.915Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5016 16.8966H84.48V10.0603H82.24V9.10315H87.7416V10.0603H85.5016V16.8966Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.145 15.8941C97.3566 16.6822 96.38 17.0754 95.215 17.0754C94.0433 17.0754 93.0666 16.6822 92.2783 15.8941C91.4916 15.1076 91.1 14.1423 91.1 12.9999C91.1 11.8576 91.4916 10.8923 92.2783 10.1058C93.0666 9.31769 94.0433 8.92444 95.215 8.92444C96.3733 8.92444 97.35 9.31769 98.1383 10.1123C98.9317 10.9053 99.3233 11.8641 99.3233 12.9999C99.3233 14.1423 98.9316 15.1076 98.145 15.8941ZM93.04 15.2408C93.6333 15.8242 94.355 16.1167 95.215 16.1167C96.0683 16.1167 96.7966 15.8242 97.3833 15.2408C97.975 14.6574 98.275 13.9083 98.275 12.9999C98.275 12.0916 97.975 11.3424 97.3833 10.7591C96.7966 10.1757 96.0683 9.88319 95.215 9.88319C94.355 9.88319 93.6333 10.1757 93.04 10.7591C92.4483 11.3424 92.1483 12.0916 92.1483 12.9999C92.1483 13.9083 92.4483 14.6574 93.04 15.2408Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.768 16.8966V9.10315H102.018L105.905 15.1644H105.95L105.905 13.6661V9.10315H106.933V16.8966H105.86L101.79 10.5364H101.745L101.79 12.0411V16.8966H100.768Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8466 28.2783C87.715 28.2783 85.1566 30.602 85.1566 33.8082C85.1566 36.9883 87.715 39.3364 90.8466 39.3364C93.985 39.3364 96.5433 36.9883 96.5433 33.8082C96.5433 30.602 93.985 28.2783 90.8466 28.2783ZM90.8466 37.1589C89.1283 37.1589 87.65 35.776 87.65 33.8082C87.65 31.8143 89.1283 30.4558 90.8466 30.4558C92.565 30.4558 94.05 31.8143 94.05 33.8082C94.05 35.776 92.565 37.1589 90.8466 37.1589ZM78.4316 28.2783C75.2933 28.2783 72.7416 30.602 72.7416 33.8082C72.7416 36.9883 75.2933 39.3364 78.4316 39.3364C81.5683 39.3364 84.1216 36.9883 84.1216 33.8082C84.1216 30.602 81.5683 28.2783 78.4316 28.2783ZM78.4316 37.1589C76.7116 37.1589 75.2283 35.776 75.2283 33.8082C75.2283 31.8143 76.7116 30.4558 78.4316 30.4558C80.15 30.4558 81.6283 31.8143 81.6283 33.8082C81.6283 35.776 80.15 37.1589 78.4316 37.1589ZM63.6583 29.9732V32.3229H69.4133C69.245 33.6359 68.795 34.6012 68.105 35.2739C67.265 36.0864 65.9566 36.9883 63.6583 36.9883C60.1166 36.9883 57.3433 34.2014 57.3433 30.7483C57.3433 27.2952 60.1166 24.5083 63.6583 24.5083C65.5733 24.5083 66.9666 25.2379 67.995 26.1837L69.6933 24.5278C68.255 23.1888 66.3416 22.1602 63.6583 22.1602C58.8016 22.1602 54.72 26.013 54.72 30.7483C54.72 35.4835 58.8016 39.3364 63.6583 39.3364C66.2833 39.3364 68.255 38.4979 69.805 36.9249C71.3933 35.3763 71.8883 33.1988 71.8883 31.4405C71.8883 30.8945 71.8416 30.3924 71.7583 29.9732H63.6583ZM124.068 31.7948C123.6 30.5582 122.155 28.2783 119.212 28.2783C116.295 28.2783 113.867 30.5192 113.867 33.8082C113.867 36.9054 116.27 39.3364 119.492 39.3364C122.097 39.3364 123.6 37.7878 124.218 36.8859L122.285 35.6298C121.64 36.5495 120.762 37.1589 119.492 37.1589C118.23 37.1589 117.325 36.595 116.745 35.4835L124.33 32.4237L124.068 31.7948ZM116.335 33.6359C116.27 31.5039 118.033 30.4119 119.297 30.4119C120.287 30.4119 121.127 30.8945 121.407 31.5852L116.335 33.6359ZM110.17 39H112.663V22.75H110.17V39ZM106.087 29.51H106.003C105.443 28.8633 104.375 28.2783 103.022 28.2783C100.182 28.2783 97.585 30.7093 97.585 33.826C97.585 36.9249 100.182 39.3364 103.022 39.3364C104.375 39.3364 105.443 38.7465 106.003 38.0803H106.087V38.8733C106.087 40.9874 104.928 42.1233 103.06 42.1233C101.537 42.1233 100.592 41.0508 100.202 40.1489L98.0333 41.0313C98.6583 42.497 100.313 44.3008 103.06 44.3008C105.983 44.3008 108.45 42.6238 108.45 38.5434V28.6147H106.087V29.51ZM103.235 37.1589C101.517 37.1589 100.078 35.7565 100.078 33.826C100.078 31.8777 101.517 30.4558 103.235 30.4558C104.928 30.4558 106.263 31.8777 106.263 33.826C106.263 35.7565 104.928 37.1589 103.235 37.1589ZM135.742 22.75H129.778V39H132.265V32.8429H135.742C138.503 32.8429 141.212 30.8945 141.212 27.7957C141.212 24.6984 138.497 22.75 135.742 22.75ZM135.807 30.5825H132.265V25.0104H135.807C137.663 25.0104 138.723 26.5135 138.723 27.7957C138.723 29.0534 137.663 30.5825 135.807 30.5825ZM151.178 28.2474C149.382 28.2474 147.513 29.0209 146.745 30.7353L148.952 31.6372C149.427 30.7353 150.3 30.4428 151.223 30.4428C152.513 30.4428 153.822 31.1984 153.842 32.5325V32.7032C153.392 32.4497 152.428 32.0743 151.243 32.0743C148.867 32.0743 146.445 33.3499 146.445 35.7305C146.445 37.908 148.392 39.3104 150.58 39.3104C152.253 39.3104 153.177 38.5743 153.757 37.7179H153.842V38.974H156.243V32.7405C156.243 29.8594 154.037 28.2474 151.178 28.2474ZM150.878 37.1524C150.065 37.1524 148.932 36.7592 148.932 35.776C148.932 34.5183 150.345 34.0357 151.568 34.0357C152.663 34.0357 153.177 34.2713 153.842 34.5817C153.647 36.0864 152.318 37.1524 150.878 37.1524ZM164.993 28.6033L162.135 35.6477H162.05L159.095 28.6033H156.413L160.853 38.4475L158.32 43.9254H160.918L167.76 28.6033H164.993ZM142.578 39H145.072V22.75H142.578V39Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6203_5344",
    x1: 29.0663,
    y1: 40.6773,
    x2: 7.25617,
    y2: 18.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6203_5344",
    x1: 45.1125,
    y1: 25.9981,
    x2: 12.85,
    y2: 25.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6203_5344",
    x1: 33.1027,
    y1: 23.015,
    x2: 3.52635,
    y2: -7.31963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6203_5344",
    x1: 9.72973,
    y1: 51.7709,
    x2: 22.9369,
    y2: 38.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.548ab7fef81f956cb674503743c3371d.svg";
export { ForwardRef as ReactComponent };